<div class="aya-page">
  <header class="aya-header">
    <a
      class="brand-link"
      [href]="healthChatHomeUrl"
      aria-label="Health Exam home"
    >
      <img
        class="brand-logo"
        src="assets/images/healthexam-logo.png"
        alt="Health Exam"
      />
    </a>
  </header>

  <main class="terms-main">
    <div class="terms-panel">
      <div
        class="terms-scroll"
        (scroll)="onTermsScroll($event)"
        tabindex="0"
        aria-label="Terms and conditions document"
      >
        <h1 class="terms-intro-heading">
          Please review the terms that govern your use of Health Exam.
        </h1>

        <p>
          Before using Health Exam, please review this summary and the agreements
          below. By selecting <strong>&ldquo;I Agree,&rdquo;</strong> you agree to
          the Terms of Use and acknowledge the Privacy Policy. If your
          organization is subject to Health Exam&rsquo;s Business Associate
          Agreement (BAA), the BAA also governs Health Exam&rsquo;s handling of
          Protected Health Information (PHI) on its behalf.
        </p>

        <section>
          <h2>Health Exam is a decision-support tool</h2>
          <p>
            Health Exam, including Aya AI, provides health information,
            educational content, and clinical decision-support tools. It does not
            provide medical advice, diagnosis, or treatment or create a
            physician-patient relationship.
          </p>
          <p>
            AI-generated information may be incomplete, inaccurate, or outdated.
            Healthcare professionals remain responsible for clinical decisions
            and should independently verify information before relying on it.
          </p>
        </section>

        <section>
          <h2>Information you provide</h2>
          <p>
            Health Exam may collect information you provide, including account
            information, credentials, prompts, questions, uploaded files, and
            feedback, as well as certain device, usage, and technical
            information, as described in the Privacy Policy.
          </p>
          <p>
            Only submit PHI or information about another person when necessary
            and when you are authorized to do so.
          </p>
        </section>

        <section>
          <h2>Acceptable Use</h2>
          <p>
            You may use Health Exam only for lawful, authorized purposes and in
            accordance with the Terms of Use. You may not misuse or interfere
            with the Services; attempt unauthorized access; circumvent security
            or usage restrictions; reverse engineer, decompile, or disassemble
            the Services; or use screen scraping, web scraping, bots, crawlers,
            spiders, automated scripts, or similar tools to access, extract,
            copy, monitor, or interact with Health Exam, Aya AI, or their
            content, systems, models, or underlying technology, except where
            expressly permitted by Health Exam or applicable law.
          </p>
        </section>

        <section>
          <h2>AI processing and privacy</h2>
          <p>
            Information submitted to Aya AI may be processed by Health Exam and
            trusted service providers to operate, secure, and evaluate the
            Services.
          </p>
          <p>
            Health Exam does not sell your Personal Information or share your
            questions or conversations for cross-context behavioral advertising.
          </p>
          <p>
            When Health Exam acts as a Business Associate, PHI is handled
            according to the BAA. Health Exam does not use PHI to train or
            fine-tune generally available AI models. PHI may be de-identified in
            accordance with HIPAA and used as permitted by the BAA.
          </p>
        </section>

        <section>
          <h2>Your responsibilities</h2>
          <p>
            You are responsible for your use of Health Exam and the information
            you submit. Healthcare professionals remain responsible for
            exercising independent professional judgment, complying with
            applicable requirements, and verifying AI-generated information
            before using it for patient care or clinical decisions.
          </p>
        </section>

        <section>
          <h2>Important legal terms</h2>
          <p>
            Your use of Health Exam is governed by the Terms of Use, which
            contain important provisions regarding permitted use, intellectual
            property, disclaimers, limitations of liability, indemnification,
            termination, dispute resolution, limitations on claims, class-action
            waivers where permitted by law, and governing law and venue.
          </p>
          <p>Please review the complete documents:</p>
          <ul class="terms-doc-links">
            <li>
              <a [href]="termsOfUseUrl" target="_blank" rel="noopener noreferrer"
                >Terms of Use</a
              >
            </li>
            <li>
              <a
                [href]="privacyPolicyUrl"
                target="_blank"
                rel="noopener noreferrer"
                >Privacy Policy</a
              >
            </li>
            <li>
              <a [href]="baaUrl" target="_blank" rel="noopener noreferrer"
                >Business Associate Agreement</a
              >
            </li>
          </ul>
        </section>

        <section>
          <h2>Acknowledgement</h2>
          <p>By selecting <strong>&ldquo;I Agree,&rdquo;</strong> I acknowledge that:</p>
          <ul>
            <li>
              I have had the opportunity to review the Terms of Use, Privacy
              Policy, and applicable BAA.
            </li>
            <li>
              I agree to the Terms of Use and acknowledge the Privacy Policy.
            </li>
            <li>
              I understand that Health Exam and Aya AI are decision-support
              tools and do not replace independent medical judgment or
              professional care.
            </li>
            <li>
              I am authorized to submit any information, including PHI, that I
              provide through the Services.
            </li>
            <li>
              If I use Health Exam on behalf of an organization, my use is also
              subject to that organization&rsquo;s applicable agreements.
            </li>
          </ul>
        </section>

        <p class="terms-end-marker" aria-hidden="true">&nbsp;</p>
      </div>

      <p class="terms-error" *ngIf="error" role="alert">{{ error }}</p>

      <div class="terms-actions">
        <button
          type="button"
          class="primary-pill-btn"
          [disabled]="!scrolledToEnd || submitting || redirecting"
          (click)="agree()"
        >
          {{ redirecting ? 'Continuing…' : submitting ? 'Saving…' : 'I agree' }}
        </button>
      </div>
    </div>
  </main>
</div>
